import { ChangeDetectorRef, Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
//import { RutValidator } from 'ng9-rut';
//import { RutValidator } from 'ng2-rut';
import { NgxSpinnerService } from 'ngx-spinner';
import { BehaviorSubject } from 'rxjs';
import { ObservableInspService } from 'src/app/services/observable_insp';
import { PropiedadService } from 'src/app/services/propiedad.service';
import { UserService } from 'src/app/services/user.service';
import { map, startWith } from 'rxjs/operators';
declare const swal: any;

@Component({
  selector: 'app-direccion-insp',
  templateUrl: './direccion-insp.component.html',
  styleUrls: ['./direccion-insp.component.css'],
  providers: [UserService, PropiedadService],

})
export class DireccionInspComponent implements OnInit {
  @ViewChild('direccionesDialog') direccionesDialog: TemplateRef<any>;
  displayedColumns: string[] = ["rol", "direccion", "actions"];
  secondFormGroup: FormGroup;
  public rol = new FormControl("");
  public dir = new FormControl("");
  public num = new FormControl("");
  lista_dir = new BehaviorSubject([]);
  dirs = [];
  btnContinuar = false
  primeraBusqueda = false
  segundoPaso = false;
  filteredOptions;
  @Input() info_rut: any;
  dataNum;
  datosTotales;
  dataCalle;
  direccionSolicitante: string;

  //calles
  calles
  bandera
  dires = []
  dirSeleccionada
  buscarbtn = true

  constructor(private _formBuilder: FormBuilder,
    private _userService: UserService,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private spinner: NgxSpinnerService,
    private _changeDetector: ChangeDetectorRef,
    //private rutValidator: RutValidator,
    private _router: Router,
    public observableService: ObservableInspService,
    public _prop: PropiedadService
  ) {
    this.secondFormGroup = this._formBuilder.group({
      rol: this.rol,
      dir: this.dir,
      num: this.num,
    });

    this._prop.getCalles().subscribe(response => {
      this.calles = response.calles
      this.bandera = true
      this.spinner.hide()
    }, error => {
      console.log(error)
      // this.spinner.hide()
    })

  }

  ngDoCheck() {
    this.segundoPaso = false

    if (this.lista_dir.value.length > 0) {
      this.btnContinuar = true
    }
    if (this.lista_dir.value.length > 0) {
      this.buscarbtn = false
    } else {
      this.buscarbtn = true
    }
  }

  ngOnInit(): void {
    this.dirs = [];
    //console.log('parametros en direccion ', this.info_rut);
    this.filteredOptions = this.secondFormGroup.controls.dir.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value))
    );
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.calles.filter(option => option.toLowerCase().indexOf(filterValue) === 0);
  }


  buscar_info_propiedad_rol() {
    this._userService
      .traerInfo_propiedad_rol(this.secondFormGroup.controls.rol.value)
      .subscribe(
        (response) => {
          console.log(response);
          if (response.status == "error") {
            this.secondFormGroup.controls.dir.setValue("");
            this.secondFormGroup.controls.num.setValue("");
            this.secondFormGroup.controls.rol.setValue("");
            swal({
              type: "warning",
              title: "Atención!",
              text: response.message,
              confirmButtonColor: "#3F51B5",
              confirmButtonText: "Aceptar",
              timer: 3500,
            }).then(
              () => { },
              (dismiss) => {
                if (dismiss === "timer") {
                }
              }
            );
          } else {
            if (response.dirs.length > 1) {

              for (let i = 0; i < response.dirs.length; i++) {
                const element = response.dirs[i];
                this.dires.push(element)
              }
              console.log(this.dires)
              this.dialog.open(this.direccionesDialog, { disableClose: true })
              this.spinner.hide()

            } else {
              console.log("==LINEA 619 ===");
              var rol_yaExiste = false;
              if (this.dirs.length <= 2) {
                for (let i = 0; i < this.dirs.length; i++) {
                  /* if (this.dirs[i].rol == response.rol) {
                    rol_yaExiste = true;
                  } */
                }
                if (!rol_yaExiste) {
                  //console.log("==LINEA 628 ===");
                  //console.log("response", response);
                  if (response !== 0) {
                    this.dirs.splice(0);
                    //console.log('grabo data ', response.dirs, response.info);
                    //this.dirs.push(response.data.dirs);
                    //this.dirs.push(response.dirs);

                    this.dirs[0] = response.dirs

                  } else {
                    //this.dirs.push(response.data.dirs);
                    //this.dirs.push(response.dirs);
                    this.dirs[0] = response.dirs
                    //console.log('grabo data iwal ', response);

                  }

                  this.datosTotales = this.dirs.map((dir) => {
                    //return response.data.info
                    //console.log("113 dir:", dir)
                    return dir
                  });
                  //console.log('datos resumidos ', this.datosTotales[0], response.info._PDI_Id_Direcc);

                  this.observableService.folioDire$.emit(response.info._PDI_Id_Direcc);
                  this.observableService.folioPredio$.emit(response.info._PDI_Folio_Propiedad);


                  //console.log("dirs", this.dirs, this.dirs[0]);
                  this.lista_dir.next(this.dirs[0]);
                  this.btnContinuar = true
                  this.primeraBusqueda = true

                  this.dataCalle = this.dirs[0].map((dir) => {
                    console.log(dir)
                    return dir.direcCompleta
                  });
                  /* this.dataNum = this.dirs.map((dir) => {
                    return dir[0].num
                  }); */
                  this.direccionSolicitante = this.dataCalle.toString() //+ ' ' + this.dataNum.toString()
                  console.log('direccionSolicitante ', this.direccionSolicitante);

                  this.observableService.direccion$.emit(this.direccionSolicitante);

                  this._changeDetector.detectChanges();
                  this.secondFormGroup.controls.dir.setValue("");
                  this.secondFormGroup.controls.num.setValue("");
                  this.secondFormGroup.controls.rol.setValue("");
                  if (this.dirs[0].length > 0) {
                    this.segundoPaso = true;
                  }
                } else {
                  //console.log("==LINEA 641 ===");

                  this.secondFormGroup.controls.dir.setValue("");
                  this.secondFormGroup.controls.num.setValue("");
                  this.secondFormGroup.controls.rol.setValue("");
                  swal({
                    type: "warning",
                    title: "Atención!",
                    text: "El rol ingresado ya esta agregado",
                    confirmButtonColor: "#3F51B5",
                    confirmButtonText: "Aceptar",
                    timer: 3500,
                  }).then(
                    () => { },
                    (dismiss) => {
                      if (dismiss === "timer") {
                      }
                    }
                  );
                }
              } else {
                console.log("==LINEA 662 ===");

                this.secondFormGroup.controls.dir.setValue("");
                this.secondFormGroup.controls.num.setValue("");
                this.secondFormGroup.controls.rol.setValue("");
                this._snackBar.open(
                  "Ya tiene 3 direcciones agregadas",
                  "Cerrar",
                  {
                    duration: 2000,
                  }
                );
              }
            }
          }
        },
        (error) => {
          this.secondFormGroup.controls.dir.setValue("");
          this.secondFormGroup.controls.num.setValue("");
          this.secondFormGroup.controls.rol.setValue("");
          swal({
            type: "error",
            title: "Ha ocurrido un error!",
            text: error._body,
            confirmButtonColor: "#3F51B5",
            confirmButtonText: "Aceptar",
            timer: 3500,
          }).then(
            () => { },
            (dismiss) => {
              if (dismiss === "timer") {
              }
            }
          );
        }
      );
  }

  insertarDir() {
    var rol_yaExiste = false
    if (this.dirs.length <= 2) {
      for (let i = 0; i < this.dirs.length; i++) {
        if (this.dirs[i].rol == this.dirSeleccionada.rol) {
          rol_yaExiste = true
        }
      }
      if (!rol_yaExiste) {
        console.log(this.dirSeleccionada)
        console.log("direccionesss", this.dirSeleccionada)
        var dir = {
          calle: this.dirSeleccionada.calle,
          num: this.dirSeleccionada.num,
          direcCompleta: this.dirSeleccionada.direcCompleta,
          rol: this.dirSeleccionada.rol,
          folio: this.dirSeleccionada.folio,
          iddirec: this.dirSeleccionada.iddirec
          // info: this.dirrecciones.info,
        }
        this.dirs.push(dir)
        this.lista_dir.next(this.dirs)
        console.log(this.lista_dir)
        this._changeDetector.detectChanges();

        this.dataCalle = this.dirs.map((dir) => {
          console.log(dir)
          return dir.direcCompleta
        });
        this.direccionSolicitante = this.dataCalle.toString() //+ ' ' + this.dataNum.toString()
        console.log('direccionSolicitante ', this.direccionSolicitante);
        this.observableService.folioDire$.emit(dir.iddirec);
        this.observableService.folioPredio$.emit(dir.folio);
        this.observableService.direccion$.emit(this.direccionSolicitante);

        this.secondFormGroup.controls.dir.setValue("")
        this.secondFormGroup.controls.num.setValue("")
        this.secondFormGroup.controls.rol.setValue("")
        if (this.dirs.length > 0) {
          this.segundoPaso = true
        }
        this.dialog.closeAll()
      } else {
        this.dialog.closeAll()
        this.secondFormGroup.controls.dir.setValue("")
        this.secondFormGroup.controls.num.setValue("")
        this.secondFormGroup.controls.rol.setValue("")
        swal({
          type: 'warning',
          title: 'Atención!',
          text: 'El rol ingresado ya esta agregado',
          confirmButtonColor: '#3F51B5',
          confirmButtonText: 'Aceptar',
          timer: 3500
        }).then(() => {
        }, (dismiss) => {
          if (dismiss === 'timer') {
          }
        });

      }

    } else {
      this.dialog.closeAll()
      this.spinner.hide()
      this.secondFormGroup.controls.dir.setValue("")
      this.secondFormGroup.controls.num.setValue("")
      this.secondFormGroup.controls.rol.setValue("")
      this._snackBar.open("Ya tiene 3 direcciones agregadas", "Cerrar", {
        duration: 2000,
      });
    }
  }


  // eliminar_direccion(i) {


  //   console.log("eliminar direccion", this.dirs)
  //   var filter = this.dirs[0].filter((vale, index, arr) => {
  //     return index != i;
  //   });

  //   if (this.dirs[0].length == 1) {
  //     this.btnContinuar = false
  //   }
  //   this.dirs[0] = filter;
  //   this.lista_dir.next(this.dirs[0]);

  //   this.dataCalle = this.dirs[0].map((dir) => {
  //     //console.log(dir)
  //     return dir.direcCompleta
  //   });
  //   /* this.dataNum = this.dirs.map((dir) => {
  //     return dir[0].num
  //   }); */
  //   this.direccionSolicitante = this.dataCalle.toString() //+ ' ' + this.dataNum.toString()
  //   console.log('direccionSolicitante ', this.direccionSolicitante);

  //   this.observableService.direccion$.emit(this.direccionSolicitante);


  //   //console.log(i, this.dirs, this.dirs[0], this.dirs[0].length);

  //   //console.log(this.lista_dir.length)
  //   this._changeDetector.detectChanges();
  // }

  eliminar_direccion(i, item) {
    console.log(i)
    console.log(item)
    this.btnContinuar = false
    this.segundoPaso = false
    console.log(this.dirs)
    var filter = this.dirs.filter((vale, index, arr) => {
      return index != i
    })


    if (this.lista_dir.value.length > 0) {
      this.segundoPaso = true
      this.segundoPaso = true
    }


    this.dirs = filter
    this.lista_dir.next(this.dirs)
    this._changeDetector.detectChanges();
  }

  buscar_info_propiedad_direccion() {
    var calle = "";

    calle = this.secondFormGroup.controls.dir.value;

    calle.toUpperCase();
    this._userService.traerInfo_propiedad_direccion(calle.toUpperCase(), this.secondFormGroup.controls.num.value)
      .subscribe(
        (response) => {
          console.log("entre en buscar por direccion", response);
          var dir_yaExiste = false;
          if (response.status == "error") {
            this.secondFormGroup.controls.dir.setValue("");
            this.secondFormGroup.controls.num.setValue("");
            this.secondFormGroup.controls.rol.setValue("");

            swal({
              type: "warning",
              title: "Atención!",
              text: response.message,
              confirmButtonColor: "#3F51B5",
              confirmButtonText: "Aceptar",
              timer: 3500,
            }).then(
              () => { },
              (dismiss) => {
                if (dismiss === "timer") {
                }
              }
            );
          } else {


            if (response.dirs.length > 1) {

              for (let i = 0; i < response.dirs.length; i++) {
                const element = response.dirs[i];
                this.dires.push(element)
              }
              console.log(this.dires)
              this.dialog.open(this.direccionesDialog, { disableClose: true })
              this.spinner.hide()

            } else {
              if (this.dirs.length <= 2) {
                for (let i = 0; i < this.dirs.length; i++) {
                  /* console.log("dirs", this.dirs, this.dirs[i],response);
                  console.log("response::: ", this.dirs[i].calle," == ",response.calle," && ",this.dirs[i].num," == ",response.num);
                  if (this.dirs[i].calle == response.calle && this.dirs[i].num == response.num) {
                    dir_yaExiste = true;
                    console.log("este dio true response::: ", this.dirs[i].calle," == ",response.calle," && ",this.dirs[i].num," == ",response.num);
                  } */
                }
                if (!dir_yaExiste) {
                  this.dirs.splice(0);
                  //this.dirs.push(response.dirs);
                  this.dirs[0] = response.dirs

                  /* if(this.dirs.length==1){
                    this.dirs.push(response.dirs);
                  } */

                  //console.log("response 290:", response.dirs, this.dirs[0])
                  this.lista_dir.next(this.dirs[0]);

                  this.dataCalle = this.dirs[0].map((dir) => {
                    //console.log(dir)
                    return dir.direcCompleta
                  });
                  /* this.dataNum = this.dirs.map((dir) => {
                    return dir[0].num
                  }); */
                  this.direccionSolicitante = this.dataCalle.toString() //+ ' ' + this.dataNum.toString()
                  console.log('direccionSolicitante ', this.direccionSolicitante);

                  this.observableService.direccion$.emit(this.direccionSolicitante);


                  this.btnContinuar = true
                  this._changeDetector.detectChanges();
                  this.secondFormGroup.controls.dir.setValue("");
                  this.secondFormGroup.controls.num.setValue("");
                  this.secondFormGroup.controls.rol.setValue("");
                  if (this.dirs[0].length > 0) {
                    this.segundoPaso = true;
                  }
                } else {
                  this.secondFormGroup.controls.dir.setValue("");
                  this.secondFormGroup.controls.num.setValue("");
                  this.secondFormGroup.controls.rol.setValue("");
                  swal({
                    type: "warning",
                    title: "Atención!",
                    text: "La dirección ingresada ya esta agregada",
                    confirmButtonColor: "#3F51B5",
                    confirmButtonText: "Aceptar",
                    timer: 3500,
                  }).then(
                    () => { },
                    (dismiss) => {
                      if (dismiss === "timer") {
                      }
                    }
                  );
                }
              } else {
                this.secondFormGroup.controls.dir.setValue("");
                this.secondFormGroup.controls.num.setValue("");
                this.secondFormGroup.controls.rol.setValue("");
                this._snackBar.open(
                  "Ya tiene 3 direcciones agregadas",
                  "Cerrar",
                  {
                    duration: 2000,
                  }
                );
              }
            }
          }
        },
        (error) => {
          console.log(error);

          this.secondFormGroup.controls.dir.setValue("");
          this.secondFormGroup.controls.num.setValue("");
          this.secondFormGroup.controls.rol.setValue("");
          swal({
            type: "error",
            title: "Ha ocurrido un error!",
            text: error._body,
            confirmButtonColor: "#3F51B5",
            confirmButtonText: "Aceptar",
            timer: 3500,
          }).then(
            () => { },
            (dismiss) => {
              if (dismiss === "timer") {
              }
            }
          );
        }
      );
  }



}
